var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-progress-linear',{staticClass:"mt-4 mb-2",attrs:{"color":_vm.progressLinearColor,"height":"20","value":_vm.getProgressbarValue(),"rounded":""}}),_c('span',[_vm._v(_vm._s(_vm.capacityPhrase))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }